<template>
  <van-actionsheet v-model="value" title="请选择支付方式" class="channel-chooser">
    <div class="channel-item" @click="toBuy('alipay')">
      <i class="iconfont icon-alipay_nor alipay-color"></i>
      <span>支付宝支付</span>
    </div>
    <div class="channel-item border" @click="toBuy('wechat')">
      <i class="iconfont icon-wechat_nor wechat-color"></i>
      <span>微信支付</span>
    </div>
  </van-actionsheet>
</template>
<script>
  import Vue from 'vue'
  import {Actionsheet} from 'vant';
  import channels from '../../constant/channels'
  import buyVIP from '../../api/order'
  import {click_event} from '../../tools/mgtv/analysis'

  Vue.use(Actionsheet);

  export default {
    name: 'ChannelChooser',
    data: function () {
      return {
        product_id: null,
        value: false,
        channels: channels,
      }
    },
    props: [],
    methods: {
      show(params) {
        this.value = true;
        this.product_id = params.product_id;
        click_event('拉起渠道选择器');
      },
      toBuy(channel) {
        this.value = false;
        buyVIP(this.product_id, channel);
      }

    },
    computed: {

    },
  };
</script>


<style lang="stylus">
  .wechat-color
    color #26b427

  .alipay-color
    color #2e94f3

  .channel-chooser
    .border
      border-bottom 1px solid #eaeaea
    .channel-item
      height 60px
      position relative
      display flex
      align-items center
      > i
        font-size 28px
        margin-left 2.8rem
      > span
        font-size 16px
        height @height
        line-height: @height
        margin-left .1rem

    　

</style>



// WEBPACK FOOTER //
// src/components/Popups/ChannelChooser.vue